"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const selectors_1 = require("@/store/ducks/products/selectors");
const products_1 = require("@/store/ducks/products");
const index_view_1 = __importDefault(require("./index.view"));
function ProductsToast() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const productToastStatus = (0, react_redux_1.useSelector)(selectors_1.productToastSelector);
    react_1.default.useEffect(() => {
        let close = undefined;
        if (productToastStatus?.isOpen) {
            close = setInterval(() => {
                dispatch((0, products_1.closeProductToast)());
            }, 3000);
        }
        return () => clearInterval(close);
    }, [productToastStatus?.isOpen, products_1.closeProductToast, dispatch]);
    const onClose = react_1.default.useCallback((event, reason) => {
        if (reason === "clickaway") {
            dispatch((0, products_1.closeProductToast)());
        }
    }, [products_1.closeProductToast, dispatch]);
    return (react_1.default.createElement(index_view_1.default, { isOpen: Boolean(productToastStatus?.isOpen), onClose: onClose, severity: productToastStatus?.status, anchorOrigin: { horizontal: "right", vertical: "top" }, message: productToastStatus?.message }));
}
exports.default = ProductsToast;
